import React, { useState } from 'react';
import Modal from './Modal';
import api from '../api';

// Dialog: Verlaufshistorie aller aktiven Schwimmer als Excel exportieren

const iso = (d) => d.toLocaleDateString('sv-SE');
const heute = () => iso(new Date());

function zeitraum(art) {
  const jetzt = new Date();
  const jahr = jetzt.getFullYear();
  switch (art) {
    case 'jahr': return [`${jahr}-01-01`, heute()];
    case 'vorjahr': return [`${jahr - 1}-01-01`, `${jahr - 1}-12-31`];
    case '12monate': { const d = new Date(jetzt); d.setFullYear(jahr - 1); d.setDate(d.getDate() + 1); return [iso(d), heute()]; }
    case '3monate': { const d = new Date(jetzt); d.setMonth(d.getMonth() - 3); d.setDate(d.getDate() + 1); return [iso(d), heute()]; }
    default: return [`${jahr}-01-01`, heute()];
  }
}

const VORAUSWAHL = [
  ['jahr', 'Dieses Jahr'], ['vorjahr', 'Letztes Jahr'], ['12monate', 'Letzte 12 Monate'], ['3monate', 'Letzte 3 Monate'],
];

export default function VerlaufExport({ onClose }) {
  const [[von, bis], setZeitraum] = useState(() => zeitraum('jahr'));
  const [laden, setLaden] = useState(false);
  const [fehler, setFehler] = useState('');

  const ungueltig = !von || !bis || von > bis;

  const exportieren = async () => {
    setLaden(true);
    setFehler('');
    try {
      const r = await api.get('/api/admin/schwimmer/verlauf-export', { params: { von, bis }, responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }));
      const link = document.createElement('a');
      link.href = url;
      link.download = `schwimmer_verlauf_${von}_bis_${bis}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      onClose();
    } catch (err) {
      // Fehlermeldung steckt bei responseType 'blob' als Blob in der Antwort
      let text = 'Export fehlgeschlagen';
      try { text = JSON.parse(await err.response.data.text()).error || text; } catch { /* Standardtext */ }
      setFehler(text);
    } finally {
      setLaden(false);
    }
  };

  return (
    <Modal title="Verlaufshistorie exportieren (Excel)" onClose={onClose} size="md">
      <p style={{ fontSize: '0.88rem', color: 'var(--text-muted)', marginBottom: '1rem' }}>
        Exportiert die Verlaufshistorie aller <strong>aktiven Schwimmer</strong> im gewählten Zeitraum.
      </p>

      <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap', marginBottom: '0.75rem' }}>
        {VORAUSWAHL.map(([k, l]) => (
          <button key={k} type="button" className="btn btn-secondary btn-sm" onClick={() => setZeitraum(zeitraum(k))}>{l}</button>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
        <div className="form-group">
          <label className="form-label">Von</label>
          <input type="date" className="form-control" value={von} max={bis || undefined}
            onChange={e => setZeitraum([e.target.value, bis])} />
        </div>
        <div className="form-group">
          <label className="form-label">Bis</label>
          <input type="date" className="form-control" value={bis} min={von || undefined}
            onChange={e => setZeitraum([von, e.target.value])} />
        </div>
      </div>
      {von && bis && von > bis && <div className="alert alert-error">Das Von-Datum liegt nach dem Bis-Datum.</div>}

      <div style={{ background: '#f4f7fb', border: '1px solid var(--border)', borderRadius: 6, padding: '0.6rem 0.8rem', fontSize: '0.8rem', lineHeight: 1.6, marginBottom: '1rem' }}>
        <strong>Die Excel-Datei enthält die Blätter:</strong>
        <ul style={{ margin: '0.25rem 0 0', paddingLeft: '1.1rem' }}>
          <li><strong>Übersicht</strong> – eine Zeile pro Kind: aktuelle Gruppe, Wechsel und abgeschlossene Stufen, Anwesenheit, Aufnahmeantrag</li>
          <li><strong>Chronik</strong> – alle Ereignisse in zeitlicher Reihenfolge</li>
          <li><strong>Gruppenverlauf</strong>, <strong>Anwesenheit</strong>, <strong>Übungen</strong> – die Einzeldaten</li>
        </ul>
        <div style={{ marginTop: '0.35rem', color: 'var(--text-muted)' }}>
          Kontaktdaten und gesundheitliche Hinweise sind nicht enthalten. Die Datei enthält trotzdem
          personenbezogene Daten von Kindern – bitte nicht weitergeben und nach Gebrauch löschen. Der Export wird protokolliert.
        </div>
      </div>

      {fehler && <div className="alert alert-error">{fehler}</div>}

      <div className="modal-actions">
        <button className="btn btn-secondary btn-sm" onClick={onClose} disabled={laden}>Abbrechen</button>
        <button className="btn btn-primary btn-sm" onClick={exportieren} disabled={laden || ungueltig} style={{ marginLeft: 'auto' }}>
          {laden ? 'Wird erstellt…' : '📊 Excel herunterladen'}
        </button>
      </div>
    </Modal>
  );
}
